import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ExtractKeyGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url = state.url;
        const key = this.extractKeyFromUrl(url);
        if (key) {
            this.router.navigate(['public/main/dashboard']);
           this.setChargerKey(key);
            return false; // Prevent default navigation, since we manually navigate
        }
        return true;
    }

    private extractKeyFromUrl(url: string): string {
        const keyMatch = url.match(/\/order\/([^\/]+)/);
        return keyMatch ? keyMatch[1] : '';
    }

    private setChargerKey(key: string) {
        localStorage.setItem('charger-token', key);
        console.log('set',key);
        // localStorage.removeItem('charger-token');
    }
}
